const elemZoom = (w, h, fix) => {
    let viewport, widthRatio, heightRatio;
    let game = {width: w, height: h};
    //pc/모바일 구분처리
    viewport = {width: window.innerWidth, height:window.innerHeight};
    // console.log('viewport', viewport);
    if(fix == undefined){
        widthRatio = viewport.width / game.width;
        heightRatio = viewport.height / game.height;
        document.body.style.transform = `scale(${widthRatio}, ${heightRatio}) translateX(-50%)`;
    }else{
        //body의 높이가 viewport보다 큰경우
        if (game.height / game.width > viewport.height / viewport.width) {
            heightRatio = viewport.height / game.height;
            document.body.style.transform = `scale(${heightRatio}) translateX(-50%)`;
        } else {
            widthRatio = viewport.width / game.width;
            document.body.style.transform = `scale(${widthRatio}) translateX(-50%)`;
        }
    }
};
export default elemZoom;